import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import AssignmentLateOutlinedIcon from '@mui/icons-material/AssignmentLateOutlined';
import RuleOutlinedIcon from '@mui/icons-material/RuleOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import { navigator } from '@types';

const financeNav = (demurrageRatesLive: boolean) => {
	const root = `/finance`;
	return [
		{
			label: 'Shipper Billing',
			icon: (color: string) => <ReceiptOutlinedIcon style={{ color: color }}/>,
			link: `/finance/shipper_billing`,
			enabled: true,
			domain: 'spa',
			activeURL: 'shipper_billing'
		},
		{
			label: 'Carrier Billing',
			icon: (color: string) => <ReceiptLongOutlinedIcon style={{ color: color }}/>,
			link: `/finance/carrier_billing`,
			enabled: true,
			domain: 'spa',
			activeURL: 'carrier_billing'
		},
		{
			label: 'Finance Approval',
			icon: (color: string) => <RuleOutlinedIcon style={{ color: color }} />,
			link: `/finance/approvals`,
			enabled: true,
			domain: 'spa',
			activeURL: 'approvals'
		},
		{
			label: 'Issues & Claims',
			icon: (color: string) => <AssignmentLateOutlinedIcon style={{ color: color }} />,
			link: `/finance/issues`,
			enabled: true,
			domain: 'spa',
			activeURL: 'issues'
		},
		{
			label: 'Invoice Report',
			icon: (color: string) => <VerifiedUserOutlinedIcon style={{ color: color }} />,
			link: `/finance/invoice_report`,
			enabled: true,
			domain: 'spa',
			activeURL: 'invoice_report'
		},
		{
			label: 'Invoice Management',
			icon: (color: string) => <CurrencyExchangeIcon style={{ color: color }}/>,
			link: `${root}/invoice_management`,
			enabled: true,
			domain: 'spa',
			activeURL: 'invoice_management'
		},
		{
			label: 'FastPay Budget',
			icon: (color: string) => <AccountBalanceWalletOutlinedIcon style={{ color: color }}/>,
			link: `${root}/fastpay_budget`,
			enabled: true,
			domain: 'spa',
			activeURL: 'fastpay_budget'
		},
		{
			label: 'Demurrage Rates',
			icon: (color: string) => <AccessTimeOutlinedIcon style={{ color: color }}/>,
			link: `${root}/demurrage/rate-cards`,
			enabled: demurrageRatesLive,
			domain: 'spa',
			activeURL: 'demurrage'
		},
	] as navigator[];
}

export default financeNav;
